export default __webpack_public_path__ + "static/media/union_ac.dd5f8764.png";